export default "__VITE_ASSET__136115ca__"